// Turkish translations
const tr = {
  // Header translations
  transaction: 'İşlem',
  prop: 'Prop',
  explore: 'Keşfet',
  profit: 'Kar',
  assets: 'Varlık',
  credit: 'Kredi',
  balance: 'Bakiye',
  freeMargin: 'Serbest Teminat',
  margin: 'Teminat',
  marginLevel: 'Teminat Seviyesi',
  openRealAccount: 'Gerçek Hesap Aç',
  
  // Market Watch
  marketWatch: 'Piyasa İzleme',
  favorites: 'Favoriler',
  mostActive: 'En Çok Hareket Eden',
  all: 'Tümü',
  searchSymbols: 'Sembol ara...',
  
  // Trading Actions
  buy: 'AL',
  sell: 'SAT',
  close: 'Kapat',
  
  // Trading Modal
  market: 'Piyasa',
  pending: 'Bekleyen',
  lot: 'Lot',
  price: 'Fiyat',
  optional: 'İsteğe bağlı',
  marketOrder: 'Piyasa Emri',
  pendingOrder: 'Bekleyen Emir',
  executionPrice: 'İcra Fiyatı',
  
  // Positions Panel
  open: 'Açık',
  openPositions: 'Açık Pozisyonlar',
  pending: 'Bekleyen',
  pendingOrders: 'Bekleyen Emirler',
  closed: 'Kapanan',
  closedPositions: 'Kapanan Pozisyonlar',
  finance: 'Finans',
  noOpenPositions: 'Hiç açık pozisyonunuz yok. İşlem yapmaya başlayın, açık pozisyonlarınızı burada göreceksiniz.',
  noPendingOrders: 'Bekleyen emir bulunmamaktadır.',
  noClosedPositions: 'Kapanan pozisyon bulunmamaktadır.',
  noFinancialHistory: 'Finansal işlem geçmişi bulunmamaktadır.',
  
  // Common terms
  symbol: 'Sembol',
  type: 'Tip',
  pnl: 'K/Z',
  swap: 'Swap',
  commission: 'Komisyon',
  spread: 'Spread',
  time: 'Zaman',
  
  // Account info
  equity: 'Özkaynak',
  usedMargin: 'Kullanılan Teminat',
  accountBalance: 'Hesap Bakiyesi',
  
  // Connection status
  connected: 'Bağlı',
  connecting: 'Bağlanıyor...',
  disconnected: 'Bağlantı Kesildi',
  
  // Mobile-specific translations
  accountSummary: 'Hesap Özeti',
  selectField: 'Alan Seç',
  
  // Modal-specific translations
  buyOrder: 'Alış Emri',
  sellOrder: 'Satış Emri',
  
  // Navigation translations
  symbols: 'Semboller',
  chart: 'Grafik',
  positions: 'Pozisyonlar',
  
  // Account management
  account: 'Hesap',
  notifications: 'Bildirimler',
  markAllRead: 'Tümünü Okundu Olarak İşaretle',
  noNotifications: 'Bildirim yok',

  // Account creation
  createAccount: 'Hesap Oluştur',
  newAccount: 'Yeni Hesap Oluştur',
  accountType: 'Hesap Türü',
  selectAccountType: 'Hesap türünü seçin',
  password: 'Parola',
  confirmPassword: 'Parola Onayı',
  enterPassword: 'Hesap parolasını girin',
  reenterPassword: 'Parolayı tekrar girin',
  liveAccount: 'Canlı Hesap',
  demoAccount: 'Demo Hesap',
  practiceAccount: 'Pratik Hesap',
  islamicAccount: 'İslami Hesap',
  passwordMismatch: 'Parolalar eşleşmiyor!',

  // Market Watch Settings Modal
  marketWatchSettings: 'Piyasa İzleme Ayarları',
  general: 'Genel',
  display: 'Görünüm',
  generalSettings: 'Genel Ayarlar',
  displaySettings: 'Görünüm Ayarları',
  autoRefresh: 'Otomatik Yenileme',
  autoRefreshDesc: 'Fiyatları otomatik olarak yenile',
  soundAlerts: 'Ses Uyarıları',
  soundAlertsDesc: 'Fiyat değişimleri için ses uyarıları',
  updateInterval: 'Güncelleme Aralığı',
  second: 'saniye',
  seconds: 'saniye',
  showSpread: 'Spread Göster',
  showSpreadDesc: 'Alış-satış farkını göster',
  showVolume: 'Hacim Göster',
  showVolumeDesc: 'İşlem hacmini göster',
  decimalPlaces: 'Ondalık Basamak',
  colorTheme: 'Renk Teması',
  default: 'Varsayılan',
  greenRed: 'Yeşil-Kırmızı',
  blueOrange: 'Mavi-Turuncu',
  save: 'Kaydet',

  // Technical Indicators
  indicators: 'İndikatörler',
  technicalIndicators: 'Teknik İndikatörler',
  sma20: 'SMA 20',
  sma50: 'SMA 50',
  ema12: 'EMA 12',
  ema26: 'EMA 26',
  rsi14: 'RSI 14',
  bollingerBands: 'Bollinger Bantları',
  trendLine: 'Trend Çizgisi',
  dynamicTrend: 'Dinamik Trend',
  movingAverage: 'Hareketli Ortalama',
  exponentialMovingAverage: 'Üssel Hareketli Ortalama',
  relativeStrengthIndex: 'Göreceli Güç Endeksi',
  macd: 'MACD',
  stochastic: 'Stokastik',
  atr: 'ATR',
  volume: 'Hacim',
  
  // Chart loading states
  loadingChart: 'Grafik Yükleniyor...',
  initializing: 'Başlatılıyor',
  chartReady: 'Grafik Hazır',

  // Performance table
  performance: 'Başarım',
  performanceMetrics: 'Başarım Metrikleri',
  totalTrades: 'Toplam İşlem',
  winningTrades: 'Kazanan İşlem',
  losingTrades: 'Kaybeden İşlem',
  winRate: 'Kazanma Oranı',
  totalProfit: 'Toplam Kar',
  totalLoss: 'Toplam Zarar',
  netProfit: 'Net Kar',
  averageWin: 'Ortalama Kazanç',
  averageLoss: 'Ortalama Kayıp',
  profitFactor: 'Kar Faktörü',
  maxDrawdown: 'Maksimum Çekim',
  consecutiveWins: 'Ardışık Kazanç',
  consecutiveLosses: 'Ardışık Kayıp',
  totalVolume: 'Toplam Hacim',
  tradingHistory: 'İşlem Geçmişi',
  loading: 'Yükleniyor...',
  noTradeHistory: 'İşlem geçmişi bulunamadı',

  // Positions table specific translations
  id: 'ID',
  amount: 'Miktar',
  openTime: 'Açılış Zamanı',
  openPrice: 'Açılış Fiyatı',
  closePrice: 'Kapanış Fiyatı',
  stopLoss: 'Zararı Durdur',
  takeProfit: 'Kar Al',
  actions: 'İşlemler',
  edit: 'Düzenle',
  searchSymbol: 'Sembol ara...',
  loadingPositions: 'Pozisyonlar yükleniyor...',
  trading: 'İşlem',
  orders: 'Emirler',
  history: 'Geçmiş',
  openPositionsAndPending: 'Açık Pozisyonlar ve Beklemede Olanlar',
  previous: 'Önceki',
  next: 'Sonraki',
  page: 'Sayfa',
  of: '/',
  noData: 'Veri bulunamadı',
  items: 'öğe',
  itemsPerPage: 'Sayfa başına öğe',
  
  // Orders specific translations
  orderType: 'Emir Türü',
  orderPrice: 'Emir Fiyatı',
  currentPrice: 'Güncel Fiyat',
  placed: 'Yerleştirildi',
  expires: 'Süre Sonu',
  gtc: 'İptal Edilene Kadar',
  cancel: 'İptal Et',
  noOrdersAvailable: 'Beklemede olan emir bulunmuyor',
  
  // Loading states
  loadingSymbols: 'Semboller yükleniyor...',
  noSymbolsFound: 'Sembol bulunamadı',
  
  // Register/Login translations
  'Personal Information': 'Kişisel Bilgiler',
  'Account Preferences': 'Hesap Tercihleri',
  'Verification': 'Doğrulama',
  'Create Your Zonex Account': 'Zonex Hesabınızı Oluşturun',
  'Join the professional trading platform': 'Profesyonel ticaret platformuna katılın',
  'First name is required': 'Ad gereklidir',
  'Last name is required': 'Soyad gereklidir',
  'Email is required': 'E-posta gereklidir',
  'Please enter a valid email address': 'Lütfen geçerli bir e-posta adresi girin',
  'Phone number is required': 'Telefon numarası gereklidir',
  'Password is required': 'Parola gereklidir',
  'Password must be at least 8 characters': 'Parola en az 8 karakter olmalıdır',
  'Passwords do not match': 'Parolalar eşleşmiyor',
  'Please select your trading experience level': 'Lütfen ticaret deneyim seviyenizi seçin',
  'You must agree to the Terms of Service': 'Hizmet Şartlarını kabul etmelisiniz',
  'You must agree to the Privacy Policy': 'Gizlilik Politikasını kabul etmelisiniz',
  'ID document is required': 'Kimlik belgesi gereklidir',
  'Proof of address is required': 'Adres kanıtı gereklidir',
  'Registration failed': 'Kayıt başarısız oldu',
  'Registration successful! Please check your email to verify your account.': 'Kayıt başarılı! Hesabınızı doğrulamak için lütfen e-postanızı kontrol edin.',
  'Please check your email and click the verification link.': 'Lütfen e-postanızı kontrol edin ve doğrulama bağlantısına tıklayın.',
  'Previous': 'Önceki',
  'Next': 'İleri',
  'Creating Account...': 'Hesap Oluşturuluyor...',
  'Create Account': 'Hesap Oluştur',
  'Already have an account?': 'Zaten hesabınız var mı?',
  'Sign in here': 'Buradan giriş yapın',
  'Registration failed. Please try again.': 'Kayıt başarısız oldu. Lütfen tekrar deneyin.',
  
  // 404 Page
  pageNotFound: 'Sayfa Bulunamadı',
  pageNotFoundMessage: 'Aradığınız sayfa mevcut değil. Sizi geri götürelim!',
  goBack: 'Geri Dön',
  backToHome: 'Ana Sayfaya Dön',
  
  // Toast messages
  orderPlaced: 'Emri Verildi',
  orderFailed: 'Emir başarısız oldu. Lütfen tekrar deneyin.',
  orderSuccess: 'Emir başarıyla yerleştirildi',
  positionClosed: 'Pozisyon kapatıldı',
  positionCloseFailed: 'Pozisyon kapatılamadı',
  orderCancelled: 'Emir iptal edildi',
  orderCancelFailed: 'Emir iptal edilemedi',
  positionUpdated: 'Pozisyon güncellendi',
  positionUpdateFailed: 'Pozisyon güncellenemedi',
  positionsClosed: 'pozisyon kapatıldı',
  ordersCancelled: 'emir iptal edildi',
  bulkCloseFailed: 'Toplu kapatma başarısız oldu',
  bulkCancelFailed: 'Toplu iptal başarısız oldu',
  noPositionsSelected: 'Hiç pozisyon seçilmedi',
  noOrdersSelected: 'Hiç emir seçilmedi',
  
  // Edit position
  editPosition: 'Pozisyonu Düzenle',
  selected: 'seçili',
  closeSelected: 'Seçilenleri Kapat',
  clearSelection: 'Seçimi Temizle',
  
  // Partial close
  partialClose: 'Parçalı Kapatma',
  volumeToClose: 'Kapatılacak Hacim',
  closePercentage: 'Kapatma Yüzdesi',
  remaining: 'Kalan',
  closing: 'Kapatılıyor',
  estimatedProfit: 'Tahmini Kar',
  invalidVolume: 'Geçersiz hacim',
  volumeTooHigh: 'Hacim toplam miktardan fazla olamaz',
  partialCloseFailed: 'Parçalı kapatma başarısız oldu',
  closePosition: 'Pozisyonu Kapat',
  partial: 'Kısmi',
  opened: 'Açıldı',
  closed: 'Kapatıldı',
  closeTime: 'Kapanış Zamanı',
  
  // Finance tab
  financeSection: 'Finans Bölümü',
  financeSectionDesc: 'Finansal işlemler ve hesap hareketleri burada görüntülenecek',
  description: 'Açıklama',
  reference: 'Referans',
  status: 'Durum',
  completed: 'Tamamlandı',
  failed: 'Başarısız',
  date: 'Tarih',
  noTransactions: 'İşlem bulunamadı',
  
  // Symbol Categories
  fx: 'FX',
  crypto: 'Kripto',
  popular: 'Popüler',
  stocks: 'Hisse Senetleri',
  commodities: 'Emtia',
  indices: 'Endeksler',
  price: 'Fiyat',
  
  // Chart Types
  lineChart: 'Çizgi Grafik',
  barChart: 'Çubuk Grafik',
  candlestickChart: 'Mum Grafik',
  zoomIn: 'Yakınlaştır',
  zoomOut: 'Uzaklaştır',
  resetZoom: 'Sıfırla',
  
  // Order Messages
  positionOpened: 'Pozisyon Açıldı',
  orderPending: 'Bekleyen Emir Oluşturuldu',
  
  // Indicators
  indicators: 'Göstergeler',
  technicalIndicators: 'Teknik İndikatörler',
  indicatorsSelected: 'indikatör seçildi',
  period: 'Periyot',
  stdDev: 'Standart Sapma',
  apply: 'Uygula',
  enableIndicator: 'İndikatörü Etkinleştir',
  enabled: 'Aktif',
  disabled: 'Pasif',
  parameters: 'Parametreler',
  color: 'Renk',
  selectIndicator: 'Bir indikatör seçin',
  clear: 'Temizle',
  add: 'Ekle',
  quickTrade: 'Hızlı İşlem',
  quickTradeActive: 'Hızlı İşlem Aktif',
  quickTradeInactive: 'Hızlı İşlem Pasif',
  
  // Header Mobile
  language: 'Dil',
  appearance: 'Görünüm',
  darkMode: 'Karanlık Mod',
  lightMode: 'Aydınlık Mod',
  markAllRead: 'Tümünü okundu olarak işaretle',
  noNotifications: 'Bildirim bulunmamaktadır',
  inbox: 'Gelen Kutusu',
  noMessages: 'Mesaj yok',
  noMessagesDescription: 'Şu anda mesajınız yok. Bazı bildirimlerin görünmesi zaman alabilir. Lütfen daha sonra tekrar kontrol edin.',
  support: 'Destek',
  announcement: 'Duyuru',
  noSupportMessages: 'Destek mesajı yok',
  noSupportMessagesDesc: 'Henüz destek talebi bulunmamaktadır.',
  noAnnouncements: 'Duyuru yok',
  noAnnouncementsDesc: 'Henüz duyuru bulunmamaktadır.',
  noFinanceMessages: 'Finans bildirimi yok',
  noFinanceMessagesDesc: 'Henüz finansal işlem bildirimi bulunmamaktadır.',
  justNow: 'Az önce',
  new: 'Yeni',
  completed: 'Tamamlandı',
  equity: 'Özkaynak',
  leverage: 'Kaldıraç',
  settings: 'Ayarlar',
  createNewTradingAccount: 'Yeni Ticaret Hesabı Oluştur',
  minPasswordLength: 'Minimum 8 karakter gereklidir',
  realAccount: 'Gerçek Hesap',
  tradeWithRealMoney: 'Gerçek para ile işlem yapın',
  practiceWithVirtualMoney: 'Sanal para ile pratik yapın',
  accountFeatures: 'Hesap Özellikleri',
  standardAccount: 'Standart Hesap',
  standardFeatures: 'Standart özellikler',
  swapFree: 'Swap ücretsiz',
  premiumSupport: 'Premium destek',
  zeroCommission: 'Sıfır komisyon',
  vipAccount: 'VIP Hesap',
  noCommissionAccount: 'Komisyonsuz Hesap',
  selectLeverage: 'Kaldıraç Seçin',
  leverageWarning: 'Yüksek kaldıraç yüksek risk içerir',
  minimumDeposit: 'Minimum Yatırım',
  maximumLeverage: 'Maksimum Kaldıraç',
  free: 'Ücretsiz',
  pleaseSelectAccountType: 'Lütfen hesap türü seçin',
  pleaseSelectAccountFeatures: 'Lütfen hesap özelliklerini seçin',
  accountCreatedSuccessfully: 'hesabı başarıyla oluşturuldu'
};

export default tr;